import { render, staticRenderFns } from "./SuggestionBoxView.vue?vue&type=template&id=b778f87c&scoped=true"
import script from "../js/Suggestion?vue&type=script&lang=js&external"
export * from "../js/Suggestion?vue&type=script&lang=js&external"
import style0 from "./SuggestionBoxView.vue?vue&type=style&index=0&id=b778f87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b778f87c",
  null
  
)

export default component.exports